import { HttpParams } from '@angular/common/http';

export type URLFormParams = Record<string, string[]>;

export function formParamsToString(object: URLFormParams, separator = ','): string {
  return object
    ? Object.entries(object)
        .filter(([, value]) => Array.isArray(value) && value.length)
        .map(([key, val]) => `${key}=${val.map(encodeURIComponent).join(separator)}`)
        .join('&')
    : '';
}

export function appendFormParamsToHttpParams(
  object: URLFormParams,
  params: HttpParams = new HttpParams(),
  separator = ','
): HttpParams {
  return object
    ? Object.entries(object)
        .filter(([, value]) => Array.isArray(value) && value.length)
        .reduce((p, [key, val]) => p.set(key, val.join(separator)), params)
    : params;
}

export function stringToFormParams(object: string, separator = ','): URLFormParams {
  return object
    ? object
        .split('&')
        .filter(val => val?.includes('='))
        .map(val => {
          const [key, values] = val.split('=');
          return { key: decodeURIComponent(key), value: values.split(separator).map(decodeURIComponent) };
        })
        .reduce((acc, val) => ({ ...acc, [val.key]: val.value }), {})
    : {};
}
